import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
var notUploadedChunks = []; // 已经上传过的文件chunkNumber数组
var isUploaded = false; // 文件已经上传成功了
import { mapGetters } from "vuex";
import { checkFileMd5, mergeFileMd5 } from "@/api/simpleUploader";
import SparkMD5 from "spark-md5";
var path = process.env.VUE_APP_BASE_API;
export default {
  name: "simpleUploader",
  data: function data() {
    return {
      md5: ""
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("user", ["userInfo", "token"])), {}, {
    statusText: function statusText() {
      return {
        success: "成功了",
        error: "出错了",
        uploading: "上传中",
        paused: "暂停中",
        waiting: "等待中"
      };
    },
    options: function options() {
      return {
        target: path + "/simpleUploader/upload",
        testChunks: false,
        simultaneousUploads: 5,
        chunkSize: 2 * 1024 * 1024,
        headers: {
          "Authorization": "Bearer " + this.token,
          "x-user-id": this.userInfo.ID
        },
        checkChunkUploadedByResponse: function checkChunkUploadedByResponse(chunk) {
          if (isUploaded) {
            return true; // return true 会忽略当前文件，不会再发送给后台
          } else {
            // 根据已经上传过的切片来进行忽略
            return notUploadedChunks && notUploadedChunks.some(function (item) {
              return item.chunkNumber == chunk.offset + 1;
            });
          }
        }
      };
    }
  }),
  methods: {
    // 上传单个文件
    fileAdded: function fileAdded(file) {
      this.computeMD5(file); // 生成MD5
    },
    // 计算MD5值
    computeMD5: function computeMD5(file) {
      var that = this;
      isUploaded = false; // 这个文件是否已经上传成功过
      notUploadedChunks = []; // 未成功的chunkNumber
      var fileReader = new FileReader();
      var md5 = "";
      file.pause();
      fileReader.readAsArrayBuffer(file.file);
      fileReader.onload = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
          var res;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!(file.size != e.target.result.byteLength)) {
                  _context.next = 3;
                  break;
                }
                this.error("Browser reported success but could not read the file until the end.");
                return _context.abrupt("return", false);
              case 3:
                md5 = SparkMD5.ArrayBuffer.hash(e.target.result, false);
                file.uniqueIdentifier = md5;
                if (!(md5 != "")) {
                  _context.next = 10;
                  break;
                }
                _context.next = 8;
                return checkFileMd5({
                  md5: md5
                });
              case 8:
                res = _context.sent;
                if (res.code == 0) {
                  if (res.data.isDone) {
                    // 上传成功过
                    isUploaded = true;
                    that.$message({
                      message: "该文件已经上传成功过了，秒传成功。",
                      type: "success"
                    });
                    file.cancel();
                  } else {
                    isUploaded = false;
                    notUploadedChunks = res.data.chunks;
                    if (notUploadedChunks.length) {
                      file.resume();
                    }
                  }
                }
              case 10:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }();
      fileReader.onerror = function () {
        this.error("generater md5 时FileReader异步读取文件出错了，FileReader onerror was triggered, maybe the browser aborted due to high memory usage.");
        return false;
      };
    },
    // 上传进度
    onFileProgress: function onFileProgress() {},
    // 上传成功
    onFileSuccess: function onFileSuccess(rootFile, file) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return mergeFileMd5({
                md5: file.uniqueIdentifier,
                fileName: file.name
              });
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    onFileError: function onFileError(rootFile, file, response) {
      this.$message({
        message: response,
        type: "error"
      });
    }
  }
};